import { Module } from '@nestjs/common';
import { DatabaseModule } from './modules/database/database.module';
import { CoreModule } from './modules/core/core.module';
import { DatacollectorModule } from './modules/datacollector/datacollector.module';
import { AppController } from './app.controller';
import { AppService } from './app.service';
import { ServerConfigModule } from '@ip6m/server/config';
import { TypeOrmModule } from '@nestjs/typeorm';
import { RoleEntity, UserEntity } from '@ip6m/server/data-access-user';
import { OtpEntity } from '@ip6m/server/data-access-otp';
import { ConfigEntity } from '@ip6m/server/data-access-config';
import {
  OtpEntitySubscriber,
  ServerFeatureLoginAndRegistrationModule,
} from '@ip6m/server/feature-login-and-registration';
import { BaseConnectionOptions } from 'typeorm/connection/BaseConnectionOptions';
import { EventEmitterModule } from '@nestjs/event-emitter';
import { ServerFeatureSelfCareModule } from '@ip6m/server/feature-self-care';
import { ServerFeatureConfigurationModule } from '@ip6m/server/feature-configuration';
import { environment } from '../environments/environment';
import { CustomerDbConfigEntity } from './modules/database/models/customerDbConfig.entity';
import { CustomerApiModule } from './modules/customer-api/customer-api.module';

@Module({
  imports: [
    CoreModule,
    DatabaseModule,
    DatacollectorModule,
    ServerConfigModule.register({
      frontendBaseUrl: environment.frontendBaseUrl,
      dbConfig: environment.dbConfig,
      bcryptSaltRounds: environment.bcryptSaltRounds,
      messengerService: environment.messengerService,
      jwtSecret: environment.jwtSecret
    }),
    TypeOrmModule.forRootAsync({
      useFactory: () =>
        ({
          ...environment.dbConfig,
          entities: [
            UserEntity,
            RoleEntity,
            OtpEntity,
            ConfigEntity,
            CustomerDbConfigEntity,
          ],
          subscribers: [OtpEntitySubscriber],
          synchronize: true,
        } as BaseConnectionOptions),
    }),
    EventEmitterModule.forRoot(),
    ServerFeatureLoginAndRegistrationModule,
    ServerFeatureSelfCareModule,
    ServerFeatureConfigurationModule,
    CustomerApiModule,
  ],
  controllers: [AppController],
  providers: [AppService],
})
export class AppModule {}
